<template>
  <div class="content">
    <div class="container">
      <form method="post"
            action="#"
            class="form form--register">
        <header-logo :logo-url="globalLogoUrl" />
        <h1 v-word:layout.userData1.mainHeader />
        <div class="form__section"
             v-word:layout.userData1.intro />
        <section class="form__section">
          <h2 v-word:layout.userData1.credentials.title />

          <input-text label-word="layout.userData1.credentials.email.label"
                      hint-word="layout.userData1.credentials.email.hint"
                      :wordings-editable="wordingsEditable"
                      :data="formData.email"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-password class="form__input--password"
                          label-word="layout.userData1.credentials.password.label"
                          hint-word="layout.userData1.credentials.password.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.password"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          :enablePlaceholder="!wordingsEditable" />

          <input-password class="form__input--password"
                          label-word="layout.userData1.credentials.passwordConfirm.label"
                          hint-word="layout.userData1.credentials.passwordConfirm.hint"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.password_repeat"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          :enablePlaceholder="!wordingsEditable" />
        </section>

        <section class="form__section">
          <h2 v-word:layout.userData1.personal.title />

          <input-radio :data="formData.salutation"
                       :wordings="wordings"
                       label-word="layout.userData1.personal.salutation"
                       :wordings-editable="wordingsEditable"
                       :wordings-meta="wordingsMeta"
                       @change="inputChanged"
                       @wordingChange="onWordingChange"
                       @wordingCommand="runWordingCommand"
                       :opts="[{
                          titleWord: 'layout.userData1.personal.mr',
                          val: 'Herr'
                        }, {
                          titleWord: 'layout.userData1.personal.mrs',
                          val: 'Frau'
                        }]" />

          <input-text label-word="layout.userData1.personal.title.label"
                      hint-word="layout.userData1.personal.title.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.title"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.personal.name.label"
                      hint-word="layout.userData1.personal.name.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.firstname"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.personal.surname.label"
                      hint-word="layout.userData1.personal.surname.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.surname"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

        </section>
        <section class="form__section">
          <h2 v-word:layout.userData1.job.title />
          <div class="form__input form__input--checkbox">
            <div class="form__input__wrap">
              <label></label>
              <input v-model="formData.is_freelancer.val"
                     id="check"
                     type="checkbox"
                     checked="">
              <label for="check"
                     v-word:layout.userData1.job.freelancer />
            </div>
          </div>

          <!-- isFreelancer -->

          <input-text label-word="layout.userData1.job.publication.label"
                      hint-word="layout.userData1.job.publication.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.publication"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.job.company.label"
                      hint-word="layout.userData1.job.company.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.company"
                      @change="inputChanged"
                      v-bind:class="{ 'form__input--disabled': formData.is_freelancer.val }"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.job.department.label"
                      hint-word="layout.userData1.job.department.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.department"
                      @change="inputChanged"
                      v-bind:class="{ 'form__input--disabled': formData.is_freelancer.val }"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.job.position.label"
                      hint-word="layout.userData1.job.position.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.position"
                      @change="inputChanged"
                      v-bind:class="{ 'form__input--disabled': formData.is_freelancer.val }"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

        </section>

        <section class="form__section">

          <div class="form__input form__input--checkbox">
            <div class="form__input__wrap">
              <label v-word:layout.userData1.job.contactType></label>
              <input v-model="formData.address_type.val"
                     id="Adresse"
                     name="contactType"
                     value="address"
                     type="radio">
              <label for="Adresse"
                     v-word:layout.userData1.job.contactType.address />
              <input v-model="formData.address_type.val"
                     id="Postfach"
                     name="contactType"
                     value="postbox"
                     type="radio">
              <label for="Postfach"
                     v-word:layout.userData1.job.contactType.postbox />
            </div>
          </div>

          <input-text v-show="wordingsEditable || formData.address_type.val == 'postbox'"
                      label-word="layout.userData1.contact.postbox.label"
                      hint-word="layout.userData1.contact.postbox.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.post_box"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text v-show="wordingsEditable || formData.address_type.val == 'address'"
                      label-word="layout.userData1.contact.street.label"
                      hint-word="layout.userData1.contact.street.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.address"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.contact.address.label"
                      hint-word="layout.userData1.contact.address.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.zip"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.contact.city.label"
                      hint-word="layout.userData1.contact.city.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.city"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <country-select label-word="layout.userData1.contact.country.label"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          :data="formData.country"
                          @change="inputChanged"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand" />

          <input-text label-word="layout.userData1.contact.phone.label"
                      hint-word="layout.userData1.contact.phone.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.phone"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.contact.mobilePhone.label"
                      hint-word="layout.userData1.contact.mobilePhone.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.mobile_phone"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

        </section>
        <section class="form__section">
          <h2 v-word:layout.userData1.webAndSocial.title />
          <p v-word:layout.userData1.webAndSocial.intro />

          <input-text label-word="layout.userData1.webAndSocial.social_web.label"
                      hint-word="layout.userData1.webAndSocial.social_web.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.social_web"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.webAndSocial.social_xing.label"
                      hint-word="layout.userData1.webAndSocial.social_xing.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.social_xing"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.webAndSocial.social_linkedin.label"
                      hint-word="layout.userData1.webAndSocial.social_linkedin.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.social_linkedin"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.webAndSocial.social_facebook.label"
                      hint-word="layout.userData1.webAndSocial.social_facebook.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.social_facebook"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.webAndSocial.social_twitter.label"
                      hint-word="layout.userData1.webAndSocial.social_twitter.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.social_twitter"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.webAndSocial.social_instagram.label"
                      hint-word="layout.userData1.webAndSocial.social_instagram.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.social_instagram"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

        </section>
        <section class="form__section">
          <h2 v-word:layout.userData1.interests.title />
          <div class="form__section__wrap">
            <div class="form__section--left">

              <input-checkbox-group :wordings-editable="wordingsEditable"
                                    :wordings="wordings"
                                    :wordings-meta="wordingsMeta"
                                    :data="formData.activity_journalist"
                                    header-word="layout.userData1.interests.journalist"
                                    :valDef="{
                            'tv': 'layout.userData1.interests.journalist.tv.label',
                            'print': 'layout.userData1.interests.journalist.print.label',
                            'radio': 'layout.userData1.interests.journalist.radio.label',
                            'online': 'layout.userData1.interests.journalist.online.label',
                            'foto': 'layout.userData1.interests.journalist.photo.label',
                            'sonstige': 'layout.userData1.interests.journalist.other.label',
                        }"
                                    @change="inputChanged"
                                    @wordingChange="onWordingChange"
                                    @wordingCommand="runWordingCommand" />

            </div>
            <div class="form__section--right">
              <input-checkbox-group :wordings-editable="wordingsEditable"
                                    :wordings="wordings"
                                    :wordings-meta="wordingsMeta"
                                    :data="formData.activity_blogger"
                                    header-word="layout.userData1.interests.blogger"
                                    :valDef="{
                            'lifestyle-themen': 'layout.userData1.interests.blogger.lifestyle.label',
                            'food-themen': 'layout.userData1.interests.blogger.food.label',
                            'sport-themen': 'layout.userData1.interests.blogger.sport.label',
                            'musik-themen': 'layout.userData1.interests.blogger.music.label',
                            'sonstige': 'layout.userData1.interests.blogger.other.label',
                        }"
                                    @change="inputChanged"
                                    @wordingChange="onWordingChange"
                                    @wordingCommand="runWordingCommand" />

              <input-checkbox-group :wordings-editable="wordingsEditable"
                                    :wordings="wordings"
                                    :wordings-meta="wordingsMeta"
                                    :data="formData.activity_other"
                                    :valDef="{
                                        'other': 'layout.userData1.interests.others',
                                      }"
                                    @change="inputChanged"
                                    @wordingChange="onWordingChange"
                                    @wordingCommand="runWordingCommand" />
            </div>
          </div>
        </section>
        <section class="form__section">
          <div class="form__input form__input--submit">
            <button type="submit"
                    @click.prevent="submit"
                    v-word:layout.userData1.buttons.submit />
          </div>
        </section>
      </form>
    </div>
    <registration-seized-modal
      ref="registration_seized_modal"
      :wordings-editable="wordingsEditable"
      :wordings="wordings"
      :wordings-meta="wordingsMeta"
      @wordingChange="onWordingChange"
      @wordingCommand="runWordingCommand"
      :wordingsOverride="wordingsOverride" />
  </div>
</template>

<script>
import config from 'config';
import * as forms from '../utils/forms';
import * as mixins from '../mixins';
import CountrySelect from '../components/CountrySelect';
import backendConfig from '../utils/backendConfig';
import registrationSeizedModal from '../modals/RegistrationSeized';
import instanceConfig from './../utils/instanceConfig';

const formDataDef = {
  email: { '*': 1, val: '' },
  password: { '*': 1, sensitive: true },
  password_repeat: { '*': 1, sensitive: true },
  salutation: { '*': 1, val: '' },
  title: { '*': 0 },
  firstname: { '*': 1 },
  surname: { '*': 1 },
  is_freelancer: { '*': 0, type: 'bool' },
  publication: { '*': 1 },
  company: { '*': 1 },
  department: { '*': 1 },
  position: { '*': 1 },
  address_type: { '*': 0, val: 'address' },
  post_box: { '*': 1 },
  address: { '*': 1 },
  zip: { '*': 1 },
  city: { '*': 1 },
  country: { '*': 1, val: 'DE' },
  phone: { '*': 1 },
  mobile_phone: { '*': 0 },
  social_web: { '*': 0 },
  social_xing: { '*': 0 },
  social_linkedin: { '*': 0 },
  social_facebook: { '*': 0 },
  social_twitter: { '*': 0 },
  social_instagram: { '*': 0 },
  is_journalist: { '*': 0 },
  is_blogger: { '*': 0 },
  activity_journalist: { '*': 0 },
  activity_blogger: { '*': 0 },
  activity_other: { '*': 0 },
};

export const storageName = 'userData1';

export default {
  props: ['autoSubmit'],
  mixins: [mixins.wordedPage, mixins.pageWithLogo, mixins.form],
  components: { CountrySelect, registrationSeizedModal },
  created() {
    if (this.autoSubmit) {
      this.submit();
      this.$emit('noAutoSubmit');
    }
  },
  mounted() {
    if (!this.wordingsEditable) {
      instanceConfig
        .get()
        .then(config => {
          if (config['seize-registration']) {
            this.$refs['registration_seized_modal'].open();
          }
        })
        .catch(() => {});
    }
  },
  data() {
    return {
      formDataDef: formDataDef,
      formStorageName: storageName,
    };
  },
  methods: {
    submit() {
      const formData = forms.marshal(this.formData);
      let formErrors = {};

      if (this.formData.password_repeat.val !== this.formData.password.val) {
        this.hasErrors = true;
        formErrors.password_repeat = { rule: 'passwordRepeatMatch' };
      }

      formData.password = this.formData.password.val;

      this.$emit('loading');
      backendConfig.get().then(({backendUrl}) => {
        this.$http
          .post(backendUrl + config.backend.feeds.validate, formData)
          .then(function(resp) {
            this.$emit('loaded');
            this.hasErrors = forms.showErrors(this.formData, formErrors);

            if (!this.hasErrors) {
              this.gotoNext();
            } else {
              this.flash(this.wordings['layout.userData1.form.error'], 'error');
            }
          })
          .catch(function(resp) {
            if (resp.body.errors) {
              formErrors = Object.assign({}, formErrors, resp.body.errors);
            }
            this.$emit('loaded');
            this.hasErrors = forms.showErrors(this.formData, formErrors);

            if (resp.status >= 500) {
              this.flash(this.wordings['flashes.generalError'], 'error');
            } else {
              if (!this.hasErrors) {
                this.gotoNext();
              } else {
                this.flash(this.wordings['layout.userData1.form.error'], 'error');
              }
            }
          });
        });
        // Edge has some problem with finally
        // .finally(function() {
        //   this.$emit('loaded');
        //   this.hasErrors = forms.showErrors(this.formData, formErrors);

        //   if (!this.hasErrors) {
        //     this.gotoNext();
        //   }
        // });
    },
    gotoNext() {
      this.$emit('regPassword', this.formData.password.val);
      this.$router.push({ path: 'registration-2' });
    },
  },
  watch: {
    'formData.is_journalist.val'(newVal) {
      if (!newVal) {
        for (let key of Object.keys(this.formData.activity_journalist.val)) {
          this.formData.activity_journalist.val[key] = false;
        }
      }
    },
    'formData.activity_journalist.val': {
      handler() {
        if (this.formData.is_journalist.val) return;
        for (let value of Object.values(
          this.formData.activity_journalist.val,
        )) {
          if (value) {
            this.formData.is_journalist.val = true;
            return;
          }
        }
        this.isJournalist = false;
      },
      deep: true,
    },
    'formData.is_blogger.val'(newVal) {
      if (!newVal) {
        for (let key of Object.keys(this.formData.activity_blogger.val)) {
          this.formData.activity_blogger.val[key] = false;
        }
      }
    },
    'formData.activity_blogger.val': {
      handler() {
        if (this.formData.is_blogger.val) return;
        for (let value of Object.values(this.formData.activity_blogger.val)) {
          if (value) {
            this.formData.is_blogger.val = true;
            return;
          }
        }
        this.isBlogger = false;
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Registration1.vue